<script setup>
  import { computed } from 'vue'

  const props = defineProps({
    data: String,
  })

  const data = computed(() => {
    return JSON.parse(props.data)
  })

</script>

<template>
  <div class="max-w-screen-2xl mx-auto lg:px-6">
    <div
      class="bg-secondary pb-12 lg:pb-0 lg:min-h-[31.25rem] 2xl:min-h-[35rem] flex flex-col-reverse lg:grid lg:grid-cols-2 w-full"
    >
      <SwiperBase
        theme="quotes"
        pagination
      >
        <template #slides>
          <div
            v-for="quote in data.quotes"
            class="swiper-slide py-8 lg:py-20 px-6 lg:px-20"
          >
            <div
              class="quote-content"
              v-html="quote.quote"
            />
            <div
              class="quote-attendee"
            >
              <p class="~text-xs/sm text-body uppercase tracking-wider">
                {{ quote.attendee }}
              </p>
            </div>
          </div>
        </template>
      </SwiperBase>
      <div
        class="quote-slider-image"
      >
        <img
          class="w-full h-full object-cover"
          :src="data.image.url"
          :alt="data.image.alt"
        />
      </div>
    </div>
  </div>
</template>

<style lang="scss" scoped>
  .quote-content :deep(p) {
    @apply ~text-xl/3xl text-headline ~mb-6/8;
    line-height: 1.5;
  }
</style>
